module.exports = __webpack_public_path__ + "static/media/multiple-select.551c8088.gif";